import { FunctionComponent, ComponentChildren, Fragment } from 'preact';
import { useEffect, useRef } from 'preact/hooks';
import { useTranslation } from 'react-i18next';
import { FocusBoundary } from './FocusManager.styles';

interface FocusManagerProps {
  children: ComponentChildren;
  shouldFocus?: boolean;
}

const FocusManager: FunctionComponent<FocusManagerProps> = ({
  children,
  shouldFocus = true,
}) => {
  const { t } = useTranslation();
  const boundaryRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Only focus if shouldFocus is true
    if (shouldFocus && boundaryRef.current) {
      boundaryRef.current.focus();
    }
  }, [shouldFocus]); // Run when shouldFocus changes

  return (
    <Fragment>
      <FocusBoundary
        ref={boundaryRef}
        tabIndex={0}
        aria-label={t('ALT_TEXT_START_TRACKING_WIDGET')}
        data-interactive-element
        data-testid="focus-boundary"
      />
      {children}
    </Fragment>
  );
};

export default FocusManager;
